import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IProduct } from "@app/interfaces/IProduct";
import { IBasicProductModel } from "@app/interfaces/IProductUiViewModel";
import { ProductVendor } from "@app/main/components/videos/enums/CameraProductType";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ProductsService {
    constructor(private readonly http: HttpClient) { }

    getProducts(): Observable<IProduct[]> {
        return this.http.get<IProduct[]>(`/api/products`);
    }

    getProductUiViewModels(): Observable<IBasicProductModel[]> {
        return this.http.get<IBasicProductModel[]>(`/api/products/basic`);
    }

    getProductVendorString(product: IBasicProductModel): string {
        if (!product) {
            return "No product found";
        }

        return ProductVendor[product?.GroupId] || "Unknown";
    }

    sortProductsByGroup(products: IProduct[]) {
        products.sort((a, b) => {
            // First, compare GroupId
            if (a.GroupId && b.GroupId) {
                if (String(ProductVendor[a.GroupId]) < String(ProductVendor[b.GroupId])) return -1;
                if (String(ProductVendor[a.GroupId]) > String(ProductVendor[b.GroupId])) return 1;
            } else if (a.GroupId) {
                return -1;
            } else if (b.GroupId) {
                return 1;
            }

            // If GroupId is the same, compare Description
            if (a.Description && b.Description) {
                return a.Description.localeCompare(b.Description);
            } else if (a.Description) {
                return -1;
            } else if (b.Description) {
                return 1;
            }

            // If both GroupId and Description are missing or equal, maintain original order
            return 0;
        });
    }
}
